// Dependecies
import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import { withTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import { Pagination } from 'antd';
import 'antd/dist/antd.css';
import Alert from 'react-bootstrap/Alert';

// Component
import Template from '../../components/Template';
import PopUpDriverEdit from '../../components/PopUpDriverEdit';
import Reload from '../../components/Reload';

// helpers
import { patternEmail } from '../../helpers';

// Hooks
import useNotificationRead from '../../hooks/useNotificationRead';
import useUserRegister from '../../hooks/useUserRegister';
import useCity from '../../hooks/useCities';

// Images
import edit from '../../../sass/images/workshop/icon-feather-edit.svg';
import alert from '../../../sass/images/alert/alert.svg';
import notPlan from '../../../sass/images/company/not-plan.svg';
import successAlert from '../../../sass/images/alert/icon-check-alert.svg';

function UserRegistration(props) {
  const { t } = props;
  const { citiesAll } = useCity();
  const [currentPage, setCurrentPage] = useState(1);
  const [cardPerPage] = useState(6);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(cardPerPage);
  // change page
  const handleChange = (page) => {
    setCurrentPage(page);
    setMinIndex((page - 1) * cardPerPage);
    setMaxIndex(page * cardPerPage);
  };
  const { newMaintenancesCompany } = useNotificationRead();
  const { register, handleSubmit, errors, control, reset, formState, getValues, setValue } =
    useForm({
      mode: 'onChange',
    });

  const {
    openModalEdit,
    closeModal,
    openModal,
    listUsers,
    driver,
    successfullyUpdate,
    submitAdd,
    messageErrorEmail,
    messageErrorId,
    reload,
    successfully,
    packagesCompany,
  } = useUserRegister(reset);
  const { isValid } = formState;

  useEffect(() => {
    if (getValues('city') !== undefined) {
      if (getValues('city').length === 0) {
        setValue('city', '', { shouldValidate: true });
      }
    }
  }, [errors]);

  return (
    <Template
      type={4}
      newMaintenances={newMaintenancesCompany}
      classNameContainer="maintenance"
      className="container_menu maintenance driver"
    >
      {!reload || !packagesCompany ? (
        <Reload
          number={!packagesCompany ? 0 : -1}
          title={t('titleUser')}
          text={t('alert:reload')}
          img={notPlan}
          firstTxt={t('alert:first-txt')}
          secondTxt={t('alert:second-txt')}
          link={t('routers:PlansCompany')}
          linkTxt={t('alert:link-txt')}
        />
      ) : (
        <div>
          <PopUpDriverEdit
            isBlocked={openModal}
            close={closeModal}
            infoDriver={driver}
            success={successfullyUpdate}
          />
          <div className="content_dynamic history block-job-requests">
            <Row className="content_maintenace">
              <div className="header-content">
                <div className="info-tittle">
                  <h1 className="title-maintenances">{t('titleUser')}</h1>
                  <p>{t('descriptionAssistant')}</p>
                </div>
              </div>
            </Row>
            <div className="block-form">
              <form onSubmit={handleSubmit((data) => submitAdd(data))}>
                <Row className="no-gutters">
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="name" className="col-form-label">
                      {t('name')} *
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      ref={register({
                        value: true,
                        required: true,
                      })}
                    />
                    {errors.name && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="last_name" className="col-form-label">
                      {t('last_name')} *
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="last_name"
                      ref={register({
                        value: true,
                        required: true,
                      })}
                    />
                    {errors.last_name && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="identification" className="col-form-label">
                      {t('identification')} *
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="identification"
                      ref={register({
                        value: true,
                        required: true,
                      })}
                    />
                    {errors.identification && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="email" className="col-form-label">
                      {t('email')}*
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="email"
                      ref={register({
                        value: true,
                        required: true,
                        pattern: { value: patternEmail, message: t('login:invalid') },
                      })}
                    />
                    {errors.email && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.email.message ? (
                            <>{errors.email.message}</>
                          ) : (
                            <>{t('alert:required-field')}</>
                          )}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="phone" className="col-form-label">
                      {t('phone')}*
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="phone"
                      ref={register({
                        value: true,
                        required: true,
                        maxLength: {
                          value: 10,
                          message: t('register:max-10'),
                        },
                        minLength: {
                          value: 10,
                          message: t('register:min-10'),
                        },
                        pattern: {
                          value: /[0-9]$/,
                          message: t('alert:number'),
                        },
                      })}
                    />
                    {errors.phone && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.phone.message ? (
                            <>{errors.phone.message}</>
                          ) : (
                            <>{t('alert:required-field')}</>
                          )}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job driver multiple">
                    <label htmlFor="city" className="col-form-label">
                      {t('city')}*
                    </label>
                    <Controller
                      className="form-control"
                      id="city"
                      name="city"
                      control={control}
                      defaultValue=""
                      render={({ onChange, value }) => (
                        <Select
                          placeholder=""
                          autoFocus={false}
                          isMulti
                          isClearable={false}
                          id="city"
                          name="city"
                          className="form-control"
                          classNamePrefix="multiple"
                          options={citiesAll}
                          value={[...value]}
                          onChange={onChange}
                        />
                      )}
                      rules={{ required: true }}
                    />
                    {errors.city && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.city.message ? (
                            <>{errors.city.message}</>
                          ) : (
                            <>{t('alert:required-field')}</>
                          )}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={12} className="block-job driver">
                    <div className="block-button">
                      <button
                        id="BtnSubmit"
                        type="submit"
                        className={` btn btn-primary button-job driver ${
                          isValid ? '' : 'disabled'
                        }`}
                      >
                        {t('sendDriver')}
                      </button>
                      <br />
                      {messageErrorEmail && (
                        <div className="error_input alert">
                          <p>
                            <img src={alert} alt={t('alt:notification')} />
                            {t('errorEmail')}
                          </p>
                        </div>
                      )}
                      {messageErrorId && (
                        <div className="error_input alert">
                          <p>
                            <img src={alert} alt={t('alt:notification')} />
                            {t('errorId')}
                          </p>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </form>
            </div>
            <Container key={1} className="main-card card-maintenances vehicle block-hidden driver">
              <Row className="no-gutters driver table-responsive">
                <table className="table table-hover">
                  <thead className="table-drivers">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col"> {t('name')}</th>
                      <th scope="col" className="table-desktop">
                        {t('last_name')}
                      </th>
                      <th scope="col"> {t('identification')}</th>
                      <th scope="col" className="table-desktop">
                        {t('email')}
                      </th>
                      <th scope="col" className="table-desktop">
                        {t('phone')}
                      </th>
                      <th scope="col" className="table-desktop">
                        {t('city')}
                      </th>
                      <th scope="col" className="table-desktop">
                        {t('status')}
                      </th>
                      <th scope="col"> {t('action')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listUsers.map(
                      (userDriver, index) =>
                        index >= minIndex &&
                        index < maxIndex && (
                          <tr key={userDriver.id}>
                            <th scope="row">{index + 1} </th>
                            <td> {userDriver.name} </td>
                            <td className="table-desktop"> {userDriver.last_name} </td>
                            <td> {userDriver.identification} </td>
                            <td className="table-desktop"> {userDriver.email} </td>
                            <td className="table-desktop"> {userDriver.phone} </td>
                            <td className="table-desktop cities">
                              {userDriver.cities.map((city) => (
                                <>
                                  <span>{city.name}</span>
                                  <br />
                                </>
                              ))}
                            </td>
                            {userDriver.id_status === 6 ? (
                              <td className="table-desktop"> {t('statusAct')}</td>
                            ) : (
                              <td className="table-desktop"> {t('statusIna')}</td>
                            )}
                            <td>
                              <button
                                type="submit"
                                className="edit-icon-company"
                                onClick={() => {
                                  openModalEdit(userDriver.id);
                                }}
                              >
                                <img src={edit} alt="Editar información" />
                              </button>
                            </td>
                          </tr>
                        )
                    )}
                  </tbody>
                </table>
              </Row>
              <Pagination
                className="col-12"
                size="small"
                defaultCurrent={1}
                total={listUsers.length}
                defaultPageSize={cardPerPage}
                current={currentPage}
                onChange={handleChange}
              />
            </Container>
            {successfully && (
              <Alert variant="success" className="alert-response">
                <img src={successAlert} alt={t('alt:successAlert')} /> &nbsp;&nbsp;{' '}
                <p>{t('alert:success')}</p>
              </Alert>
            )}
          </div>
        </div>
      )}
    </Template>
  );
}

UserRegistration.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['driverRegistration', 'alert', 'alt', 'routers'])(UserRegistration);
